module.exports = __webpack_public_path__ + "img/default_img_1.67810574.png";